module.exports = __WEBPACK_EXTERNAL_MODULE_52__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","getISOWeek"],"commonjs":"date-fns/get_iso_week/index","commonjs2":"date-fns/get_iso_week/index"}
// module id = 52
// module chunks = 0